import React from "react";
import { useSelector } from "react-redux";

import messages from "../../../assets/locale/messages";
import ClientPortalPage from "../ClientPortalPage";

const ClientSurvey = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];

  return <ClientPortalPage title={shared.clientSurvey} />;
};

export default ClientSurvey;
